import React from "react";

const LineDotIcon = () => {
  return (
    <svg
      width="28"
      height="9"
      viewBox="0 0 28 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.4375 4.5H26.4375"
        stroke="#2F4D9C"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle cx="13.4375" cy="4.5" r="4" fill="#2F4D9C" />
    </svg>
  );
};

export default LineDotIcon;
